var map = {
	"./tapcoin/new/30tip.png": 10411,
	"./tapcoin/new/CRY.png": 61764,
	"./tapcoin/new/TAP-small.png": 24460,
	"./tapcoin/new/TAP.png": 63297,
	"./tapcoin/new/TAPCOINS-small.png": 9474,
	"./tapcoin/new/TAPCOINS.png": 12129,
	"./tapcoin/new/TAPSTOCK-small.png": 12337,
	"./tapcoin/new/TAPSTOCK.png": 68715,
	"./tapcoin/new/TON.png": 5418,
	"./tapcoin/new/USDT-small.png": 4943,
	"./tapcoin/new/USDT.png": 56595,
	"./tapcoin/new/avatar/avatar-1.png": 24774,
	"./tapcoin/new/avatar/avatar-2.png": 93337,
	"./tapcoin/new/avatar/avatar-3.png": 2025,
	"./tapcoin/new/avatar/avatar-4.png": 28018,
	"./tapcoin/new/avatar/avatar-5.png": 25571,
	"./tapcoin/new/blind/bind-box.png": 16670,
	"./tapcoin/new/blind/bind-select.png": 31329,
	"./tapcoin/new/blind/blind-container-bg.png": 65899,
	"./tapcoin/new/blind/blind-items-board.png": 29146,
	"./tapcoin/new/blind/reward-box.png": 39264,
	"./tapcoin/new/blind/reward-select.png": 6608,
	"./tapcoin/new/fortune/fortune-card-Bgblack.png": 99231,
	"./tapcoin/new/fortune/fortune-card-Bgblue.png": 8874,
	"./tapcoin/new/fortune/fortune-card-Bggreen.png": 6509,
	"./tapcoin/new/fortune/fortune-card-Bgorange.png": 61242,
	"./tapcoin/new/fortune/fortune-card-Bgpink.png": 62714,
	"./tapcoin/new/fortune/fortune-card-Bgred.png": 72867,
	"./tapcoin/new/fortune/fortune-card-Bgyellow.png": 78053,
	"./tapcoin/new/fortune/fortune-card-light.png": 53154,
	"./tapcoin/new/fortune/fortune-card.png": 35108,
	"./tapcoin/new/fortune/forturn-star.png": 97267,
	"./tapcoin/new/fortune/forturn-tag.png": 87539,
	"./tapcoin/new/fortune/orturn-synthesis-empty.png": 85965,
	"./tapcoin/new/game-small.png": 76050,
	"./tapcoin/new/gift-selector-997.png": 94592,
	"./tapcoin/new/gift-selector-arrow-997.png": 17144,
	"./tapcoin/new/gift-selector-arrow.png": 53981,
	"./tapcoin/new/gift-selector.png": 21226,
	"./tapcoin/new/gift/gift-exclusise-img.png": 89505,
	"./tapcoin/new/gift/gift-high-img.png": 11073,
	"./tapcoin/new/hot.png": 3785,
	"./tapcoin/new/icon-diamond.png": 93365,
	"./tapcoin/new/icon-gold-1.png": 22444,
	"./tapcoin/new/icon-group.png": 76515,
	"./tapcoin/new/icon-menu.png": 70354,
	"./tapcoin/new/icon-ok.png": 37674,
	"./tapcoin/new/icon-people.png": 74432,
	"./tapcoin/new/icon-profit.png": 67918,
	"./tapcoin/new/icon-ranking.png": 98853,
	"./tapcoin/new/icon-wallet.png": 16864,
	"./tapcoin/new/index-bg-gold.png": 33292,
	"./tapcoin/new/index-icon-boosts.png": 38663,
	"./tapcoin/new/index-icon-crypto.png": 91607,
	"./tapcoin/new/index-icon-frens.png": 67993,
	"./tapcoin/new/index-icon-progress.png": 59021,
	"./tapcoin/new/index-icon-slots.png": 4282,
	"./tapcoin/new/index-icon-spin.png": 50241,
	"./tapcoin/new/lock/avatar-lock-l.png": 76149,
	"./tapcoin/new/lock/avatar-lock-s.png": 5386,
	"./tapcoin/new/lock/double_p.png": 45844,
	"./tapcoin/new/lock/gift-1.png": 43010,
	"./tapcoin/new/lock/gift-2.png": 69894,
	"./tapcoin/new/lock/gift-3.png": 37356,
	"./tapcoin/new/machine/machine-arrow.png": 17336,
	"./tapcoin/new/machine/machine-bg.png": 5455,
	"./tapcoin/new/machine/machine-btn1-bg-1.png": 29058,
	"./tapcoin/new/machine/machine-btn1-bg.png": 87662,
	"./tapcoin/new/machine/machine-btn2-bg-1.png": 73990,
	"./tapcoin/new/machine/machine-btn2-bg.png": 60726,
	"./tapcoin/new/machine/machine-main-bg.png": 92956,
	"./tapcoin/new/machine/machine-title.png": 39551,
	"./tapcoin/new/menu-active-bg.png": 36962,
	"./tapcoin/new/menu-airdrop-active.png": 84387,
	"./tapcoin/new/menu-airdrop.png": 19842,
	"./tapcoin/new/menu-app-active.png": 2627,
	"./tapcoin/new/menu-app.png": 93024,
	"./tapcoin/new/menu-bg.png": 48030,
	"./tapcoin/new/menu-earn-active.png": 35656,
	"./tapcoin/new/menu-earn.png": 78194,
	"./tapcoin/new/menu-game-active.png": 57508,
	"./tapcoin/new/menu-game.png": 31929,
	"./tapcoin/new/menu-gift-active.png": 10321,
	"./tapcoin/new/menu-gift.png": 47003,
	"./tapcoin/new/menu-home-active.png": 11681,
	"./tapcoin/new/menu-home.png": 30399,
	"./tapcoin/new/menu-nft-active.png": 4654,
	"./tapcoin/new/menu-nft.png": 86814,
	"./tapcoin/new/menu-study-active.png": 63565,
	"./tapcoin/new/menu-study.png": 53568,
	"./tapcoin/new/menu-tasks-active.png": 27283,
	"./tapcoin/new/menu-tasks.png": 23570,
	"./tapcoin/new/mpay-logo.png": 34077,
	"./tapcoin/new/mpayBanner__title.png": 70369,
	"./tapcoin/new/nav-icon-achievements.png": 96289,
	"./tapcoin/new/nav-icon-bounty.png": 18689,
	"./tapcoin/new/nav-icon-code.png": 4169,
	"./tapcoin/new/nav-icon-login.png": 82097,
	"./tapcoin/new/new.png": 76794,
	"./tapcoin/new/nftInfo/nftInfo-items-bg.png": 8757,
	"./tapcoin/new/niceLucky/btn-1.png": 70699,
	"./tapcoin/new/niceLucky/btn-2.png": 72564,
	"./tapcoin/new/niceLucky/icon-buy.png": 77947,
	"./tapcoin/new/niceLucky/icon-invite.png": 15850,
	"./tapcoin/new/niceLucky/icon-shard.png": 82170,
	"./tapcoin/new/niceLucky/icon-ship.png": 54684,
	"./tapcoin/new/niceLucky/icon-task.png": 53731,
	"./tapcoin/new/niceLucky/light.png": 22540,
	"./tapcoin/new/niceLucky/niceLucky-bottom.png": 52706,
	"./tapcoin/new/niceLucky/niceLucky-item-active-bg.png": 26666,
	"./tapcoin/new/niceLucky/niceLucky-item-bg.png": 53468,
	"./tapcoin/new/niceLucky/niceLucky.png": 13243,
	"./tapcoin/new/niceLucky/niceLucky_title.png": 2036,
	"./tapcoin/new/niceLucky/ship-num.png": 42450,
	"./tapcoin/new/perHour.png": 88043
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48061;